import { inject } from '@angular/core';

import { PokerProductService } from './poker-product.service';

/**
 * Route guard for initializing Poker-app bootstrap services in Host-App.
 */

export const pokerProductDeactivateGuard = () => {
    inject(PokerProductService).deactivatePoker();
};

export const pokerProductActivateGuard = () => {
    inject(PokerProductService).activatePoker();
};
